import { Box, Columns, Column } from 'braid-design-system';

type Space =
  | 'none'
  | 'xsmall'
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge';

interface Props {
  imageUrl: string;
  children?: React.ReactNode;
  hideImageBelowDesktop?: boolean;
  contentPaddingY?: Space | { mobile?: Space; tablet?: Space; desktop?: Space };
}

export const ImageBanner = ({
  imageUrl,
  children,
  hideImageBelowDesktop = false,
  contentPaddingY = { mobile: 'large', desktop: 'xxlarge' },
}: Props) => (
  <Box background="body">
    <Columns reverse space="none" collapseBelow="desktop">
      <Column>
        <Box
          display={
            hideImageBelowDesktop
              ? { mobile: 'none', tablet: 'none', desktop: 'block' }
              : 'block'
          }
          height="full"
          width="full"
          role="img"
          style={{
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            minHeight: 230,
          }}
          src={imageUrl}
        />
      </Column>
      <Column width="1/2">
        <Box padding="large" paddingY={contentPaddingY}>
          {children}
        </Box>
      </Column>
    </Columns>
  </Box>
);
